<app-layout>
  <div class="main dashboard-main">
    <div class="header-table">
      <div class="header-title-block">
        <app-titulo>{{ dashboardTitle }}</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Gerar PDF" icon="assets/download.svg"
          [disabled]="isExportingPdf" (click)="gerarPDF()"></app-botao>
      </div>
    </div>

    <div #dashboardPdfContent class="dashboard-pdf-content" [class.exporting-pdf]="isExportingPdf">
      <div class="pdf-report-meta">
        <p class="pdf-report-title">{{ dashboardTitle }}</p>
        <p class="pdf-report-period" *ngIf="form.controls['DT_INIC'].value || form.controls['DT_FIM'].value">
          Período: {{ formatFilterDate(form.controls['DT_INIC'].value) }}
          até {{ formatFilterDate(form.controls['DT_FIM'].value) }}
        </p>
      </div>

      <div class="filters-card">
        <form [formGroup]="form" class="table-filters">
          <app-input type="datetime-local" label="Data Início" name="DT_INIC" formControlName="DT_INIC"
            width="100%"></app-input>
          <app-input type="datetime-local" label="Data Final" name="DT_FIM" formControlName="DT_FIM"
            width="100%"></app-input>
        </form>
      </div>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoEstoqueIndicadores')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('kpis')">
          <span>Indicadores Principais</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('kpis')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('kpis')">
          <div class="kpi-grid">
            <div class="kpi-card" *ngFor="let kpi of kpis">
              <span class="kpi-label">{{ kpi.label }}</span>
              <span class="kpi-value">{{ kpi.value }}</span>
              <span class="kpi-hint" *ngIf="kpi.hint">{{ kpi.hint }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoEstoqueUltimasVendas')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('vendasMes')">
          <span>Vendas por mês</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('vendasMes')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('vendasMes')">
          <div class="charts-grid" *ngIf="vendasPorMes.length; else emptyVendasMes">
            <section class="chart-card">
              <h3>Quantidade de produtos vendidos por mês</h3>
              <div class="bar-chart vertical">
                <div class="bar-item" *ngFor="let item of vendasPorMes">
                  <div class="bar-track">
                    <div class="bar-fill" [style.height.%]="barHeight(item.value, vendasPorMes)"></div>
                  </div>
                  <span class="bar-label">{{ item.label }}</span>
                  <span class="bar-value">{{ item.value }}</span>
                </div>
              </div>
            </section>
          </div>
          <ng-template #emptyVendasMes>
            <p class="chart-empty">Nenhuma venda no período selecionado.</p>
          </ng-template>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoEstoqueUltimasVendas')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('produtos')">
          <span>Quantidade por produtos</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('produtos')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('produtos')">
          <ng-container
            *ngIf="quantidadePorProdutoVendido.length || quantidadePorProdutoEstoque.length; else emptyProdutos">
            <div class="charts-grid">
              <section class="chart-card">
                <h3>Quantidade por Produtos Vendidos</h3>
                <div class="bar-chart horizontal" *ngIf="quantidadePorProdutoVendido.length; else emptyVendidos">
                  <div class="h-bar-row" *ngFor="let item of quantidadePorProdutoVendido">
                    <span class="h-bar-label">{{ item.label }}</span>
                    <div class="h-bar-track">
                      <div class="h-bar-fill" [style.width.%]="barHeight(item.value, quantidadePorProdutoVendido)"></div>
                    </div>
                    <span class="h-bar-value">{{ item.value }}</span>
                  </div>
                </div>
                <ng-template #emptyVendidos>
                  <p class="chart-empty">Nenhuma venda no período.</p>
                </ng-template>
              </section>

              <section class="chart-card">
                <h3>Quantidade por Produtos em Estoque</h3>
                <div class="bar-chart horizontal" *ngIf="quantidadePorProdutoEstoque.length; else emptyEstoque">
                  <div class="h-bar-row" *ngFor="let item of quantidadePorProdutoEstoque">
                    <span class="h-bar-label">{{ item.label }}</span>
                    <div class="h-bar-track">
                      <div class="h-bar-fill alt" [style.width.%]="barHeight(item.value, quantidadePorProdutoEstoque)"></div>
                    </div>
                    <span class="h-bar-value">{{ item.value }}</span>
                  </div>
                </div>
                <ng-template #emptyEstoque>
                  <p class="chart-empty">Nenhum produto em estoque.</p>
                </ng-template>
              </section>
            </div>
          </ng-container>
          <ng-template #emptyProdutos>
            <p class="chart-empty">Sem dados de produtos no período.</p>
          </ng-template>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoEstoqueUltimasVendas')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('payment')">
          <span>Formas de pagamento</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('payment')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('payment')">
          <ng-container *ngIf="formaPagamentoDetalhe.length; else emptyPagamento">
            <div class="charts-grid payment-charts-grid">
              <section class="chart-card">
                <h3>Distribuição por forma de pagamento</h3>
                <div class="pie-layout" *ngIf="hasChartData(formaPagamento)">
                  <div class="pie-chart" [style.background]="pieGradient(formaPagamento)"></div>
                  <ul class="pie-legend">
                    <li *ngFor="let item of formaPagamentoDetalhe">
                      <i [style.background]="item.color"></i>
                      <span>{{ item.label }}</span>
                      <strong>{{ pieSlicePercent(item.valor, formaPagamento) }}%</strong>
                    </li>
                  </ul>
                </div>
              </section>

              <section class="chart-card">
                <h3>Valores por forma de pagamento</h3>
                <ul class="payment-values-list">
                  <li *ngFor="let item of formaPagamentoDetalhe">
                    <span class="payment-values-label">
                      <i [style.background]="item.color"></i>
                      {{ item.label }}
                    </span>
                    <strong>{{ formatCurrency(item.valor) }}</strong>
                  </li>
                </ul>
              </section>
            </div>
          </ng-container>
          <ng-template #emptyPagamento>
            <p class="chart-empty">Nenhum pagamento no período selecionado.</p>
          </ng-template>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoEstoqueUltimasMovimentacoes')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('movimentacoes')">
          <span>Movimentações recentes</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('movimentacoes')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('movimentacoes')">
          <ng-container *ngIf="movimentacoesPorOrigem.length; else emptyMovimentacoes">
            <div class="charts-grid">
              <section class="chart-card">
                <h3>Quantidade por origem</h3>
                <div class="bar-chart horizontal">
                  <div class="h-bar-row" *ngFor="let item of movimentacoesPorOrigem">
                    <span class="h-bar-label">{{ item.label }}</span>
                    <div class="h-bar-track">
                      <div class="h-bar-fill alt" [style.width.%]="barHeight(item.value, movimentacoesPorOrigem)"></div>
                    </div>
                    <span class="h-bar-value">{{ item.value }}</span>
                  </div>
                </div>
              </section>
            </div>
          </ng-container>
          <ng-template #emptyMovimentacoes>
            <p class="chart-empty">Nenhuma movimentação recente.</p>
          </ng-template>
        </div>
      </section>

    </div>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
